import { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import { cn } from '@sib/ui';

interface LayoutProps
  extends PropsWithChildren,
    HTMLAttributes<HTMLDivElement> {
  sidebar: ReactNode;
  topbar: ReactNode;
}

export const TOPBAR_HEIGHT = 66;

export const Layout = ({
  children,
  sidebar,
  topbar,
  ...props
}: LayoutProps) => (
  <div className="flex h-screen flex-col" {...props}>
    {topbar}
    <div
      className="flex min-w-0 flex-1 overflow-hidden"
      style={{ paddingTop: TOPBAR_HEIGHT }}
    >
      {sidebar}
      <main
        className={cn(
          'min-w-0 flex-[1_1_0%] overflow-x-auto transition-all duration-700 ease-in-out'
        )}
      >
        {children}
      </main>
    </div>
  </div>
);

Layout.displayName = 'Layout';
